// Lets deep primitives such as reference badges reach the run scope without
// threading it through every registry render. Null outside a harness, so a
// primitive mounted alone (the admin gallery, tests) degrades to static copy.
import { createContext, useContext } from 'react';

import { type HarnessScope } from '@apps/web/features/phoebe_chat_v3/model/event_types';

export const HarnessScopeContext = createContext<HarnessScope | null>(null);

export function useHarnessScope(): HarnessScope | null {
    return useContext(HarnessScopeContext);
}
